import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useSocials } from '@/composables';
import UiModal from './ui/UiModal.vue';

interface Props {
  menu: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  props: {
    menu: null
  },
  setup(__props: any) {



const { socials } = useSocials();
const supportModal = ref<null | typeof UiModal>(null);

return { __sfc: true,socials, supportModal, UiModal }
}

})